<template>
  <div>
    <button
      v-b-tooltip.hover
      type="button"
      placement="bottom"
      title="Edition deaktivieren"
      class="btn-info float-right w-100 h-100"
      @click="openModal"
    >
      <i class="fas fa-ban" />
    </button>

    <b-modal
      id="setEditionInactive"
      ref="setEditionInactive"
      hide-footer
      title="Edition deaktivieren"
      no-fade
    >
      <u-loader v-if="isLoading" />
      <div v-else>
        <div class="d-block mb-4">
          Sind Sie sicher, dass Sie diese Edition deaktivieren möchten?
        </div>
        <template v-if="issues.length > 0">
          <b>Warnungen</b>
          <ul>
            <li
              v-for="(error, index) in issues"
              :key="index"
            >
              {{ error.sourceObject }}: {{ error.issueDescription }}
            </li>
          </ul>
        </template>
        <b-button
          variant="success"
          @click="deactivateEdition()"
        >
          Ok
        </b-button>
        <b-button
          class="ml-2"
          variant
          @click="hideModal('setEditionInactive')"
        >
          Abbrechen
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  CheckPublicationRequirements,
  SetEditionInactive,
} from "@/services/contract.edition.service.js";

export default {
  name: "EditionDeactivation",
  props: {
    contractId: {
      type: String,
      required: true,
    },
    versionId: {
      type: Number,
      required: true,
    },
    editionToDeactivate: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      issues: [],
    };
  },
  methods: {
    openModal() {
      this.$refs["setEditionInactive"].show();
      this.isLoading = true;
      CheckPublicationRequirements(
        this.contractId,
        this.versionId,
        this.editionToDeactivate,
        5, //Deactivated
        (results) => {
          this.issues = results.issues;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    deactivateEdition() {
      // Add deactivation logic here
      SetEditionInactive(
        this.contractId,
        this.versionId,
        this.editionToDeactivate,
        () => {
          this.hideModal("setEditionInactive");
          this.$emit("editionDeactivated");
        },
        (error) => {
          this.errorObject = error;
          this.hideModal("setEditionInactive");
        },
      );
    },
  },
};
</script>
